import { render } from "./UserProfileOffChainBanner.vue?vue&type=template&id=c0d2aa9a&scoped=true"
import script from "./UserProfileOffChainBanner.vue?vue&type=script&lang=ts"
export * from "./UserProfileOffChainBanner.vue?vue&type=script&lang=ts"

import "./UserProfileOffChainBanner.vue?vue&type=style&index=0&id=c0d2aa9a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0d2aa9a"

export default script